// Auto-generated list of Chia's photos
// Run 'npm run update-images' to regenerate this file

export const images = [
  {
    "url": "/images/IMG_0283.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0288.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0315.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0329.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0333.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0335.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0346.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0348.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0349.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0355.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0421.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0424.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0434.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0473.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0489.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0493.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0500.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0501.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0504.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0508.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0523.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0553.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0557.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0581.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0615.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0644.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0648.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0670.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0703.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0706.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0707.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0764.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0882.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0896.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_0912.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_7591.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_7594.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_7596.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_7602.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_7614.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/IMG_7620.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  },
  {
    "url": "/images/SZGI5822.jpg",
    "alt": "Chia the therapy dog",
    "caption": ""
  }
];
